import React, { useContext } from 'react'
import { Menu as UikitMenu } from '@pancakeswap-libs/uikit'
import { useWeb3React } from '@web3-react/core'
import { allLanguages } from 'constants/localisation/languageCodes'
import { LanguageContext } from 'hooks/LanguageContext'
import useTheme from 'hooks/useTheme'
import useUikitWalletLogin from 'hooks/useUikitWalletLogin'
import { clearLastWalletId } from 'connectors/lastWallet'
import links from './config'

const Menu: React.FC = (props) => {
  const { account, deactivate } = useWeb3React()
  const login = useUikitWalletLogin()
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext)
  const { isDark, toggleTheme } = useTheme()

  const logout = () => {
    clearLastWalletId()
    deactivate()
  }

  return (
    <UikitMenu
      links={links}
      account={account as string}
      login={login}
      logout={logout}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={selectedLanguage?.code || ''}
      langs={allLanguages}
      setLang={setSelectedLanguage}
      {...props}
    />
  )
}

export default Menu
